import { render } from "./HtmlTitle.vue?vue&type=template&id=2772cd0c"
import script from "./HtmlTitle.vue?vue&type=script&lang=js"
export * from "./HtmlTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__